<app-top-navigation [openLoginWindow]="openLoginWindow" [class.blackGradient]="true"></app-top-navigation>
<div class="mainContainer">
	<div class="container-fluid">
		<div class="sectionContainer">
			<div class="topContainer" [class.joined]="joining">
				<ng-container *ngIf="!joining">
					<h3 style="margin-top: 1rem;">Join a Virtual Tour</h3>
					<form *ngIf="!flowLoading">
						<label>Meeting ID</label>
						<input class="inputKey" placeholder="Enter the meeting ID to join" #passJoin>
						<div class="acceptAgreement">
							By joining the meeting you accept the <a href="javascript:void(0)">Terms</a> and
							<a href="javascript:void(0)">Policies</a>.
						</div>
						<button class="joinTour" (click)="joinMeeting()">Join</button>
					</form>
				</ng-container>
				<ng-container *ngIf="error">
					<div class="text-danger text-center">There is not any meeting with this code.</div>
				</ng-container>
				<div class="preloader3 loader-block" *ngIf="flowLoading">
					<div class="circ1"></div>
					<div class="circ2"></div>
					<div class="circ3"></div>
					<div class="circ4"></div>
				</div>
				<ng-container *ngIf="joining">
					<h3 style="margin-top: 1rem;">Ancient Greece Cultural Heritage</h3>
					<div class="sliderContainer">
						<div class="sliderInfo row">
							<div class="left-slider-panel col-4 p-0" *ngIf="facts">
								<div class="factSelection" *ngFor="let fact of facts" (click)="selectFact(fact)" [ngClass]="{'active': fact === selectedFact}">
									<img src="{{fact.image}}" />
									<label>{{this.globalDataService.getObjectTranslation(fact.dailylifeTranslations, 'name')}}</label>
								</div>
							</div>
							<div class="col-8">
								<ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="true" *ngIf="selectedFact">
									<ng-template ngbSlide *ngFor="let fact of
									globalDataService.getObjectTranslation(selectedFact['dailylifeTranslations'], 'children')">
										<div class="picsum-img-wrapper">
											<img [src]="fact.image" [alt]="fact['shortDescription']">
										</div>
										<div class="carousel-caption">
											<h4>{{fact['shortDescription']}}</h4>
											<p class="descCaption" [innerHTML]="fact['description']" ></p>
										</div>
									</ng-template>
								</ngb-carousel>
							</div>
						</div>
					</div>
					<div class="waitingJoin">
						<div class="messageContainer">
							<div>{{waitingMessage}}</div>
							<app-timezone-converter [greeceTime]="meeting.timestamp"></app-timezone-converter>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
	<div class="footerInfo">
		<div class="row">
			<div class="col-3">
				<label>Information</label>
				<ul>
					<li>How it works</li>
					<li>News</li>
					<li>Our guide partners</li>
				</ul>
			</div>
			<div class="col-3">
				<label>Guides</label>
				<ul>
					<li>Become a partner</li>
					<li>Guide list</li>
					<li>What you need to know</li>
				</ul>
			</div>
			<div class="col-3">
				<label>Policies</label>
				<ul>
					<li>Terms</li>
					<li>Privacy Policy</li>
				</ul>
			</div>
			<div class="col-3">
				<img src="assets/images/cards/visa.png" style="width: 39px;margin-right: 11px;">
				<img src="assets/images/cards/mastercard.png" style="width: 41px;margin-right: 9px;">
				<img src="assets/images/cards/diners.png" style="margin-right: 10px;width: 92px;">
				<img src="assets/images/cards/discover.png" style="width: 52px;"> <br />
				<label>
					Powered By
					<span style="width: 92%;">
						<img src="assets/images/cards/everypay.png" style="width: 93px;">
					</span>
				</label>
			</div>
			<div class="col-12" style="font-size: .7rem;margin-top: 10px;">
				COPYRIGHT © 2021 CULTUREAPP. ALL RIGHTS RESERVED
			</div>
		</div>
	</div>
</div>